import { ProfileAvatar } from '../avatar/profile-avatar';
import { useEffect, useRef, useState } from 'react';
import ProfileMenu from '../profileMenu/profileMenu';
import { connect } from 'react-redux';
import { signOut } from '../../redux/user/user.async-thunks';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

interface DashboardMenubarProps {
  readonly bgColorClass?: string;
  readonly imageUrl?: string;
}

export const DashboardMenubar = ({ bgColorClass = '', imageUrl }: DashboardMenubarProps) => {
  const dispatch = useDispatch();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const { search } = useLocation();

  const handleAvatarClick = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleProfileClick = () => {
    const accountPath = search.includes('404=t') ? '/account?404=t' : '/account';
    navigate(accountPath);
  };

  const handleLogoutClick = async() => {
    await dispatch(signOut() as any);
    navigate('/login');
  };

  useEffect(() => {
    const handler = (e: any) => {
      if (!menuRef.current?.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
  });

  return (
    <div className={`left-0 top-0 flex w-full items-center justify-between p-4 ${bgColorClass}`}>
      {/* <div className="flex items-center">
        <Link to="/dashboard">
          <BrandLogo />
        </Link>
      </div> */}
      <div
        className="flex items-center"
        ref={menuRef}
      >
        <ProfileAvatar
          imgSrc={imageUrl}
          onClick={handleAvatarClick}
        />
        <div className="relative" >
          {isMenuOpen && (
            <ProfileMenu
              onProfileClick={handleProfileClick}
              onLogoutClick={handleLogoutClick}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const connector = connect(null, { signOut });

export default connector(DashboardMenubar);
